class TabbedContent extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-tab-title]');
    this.content = this.querySelectorAll('[data-tab-content]');

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.showContent(index);
      });
    });
  }

  showContent(index) {
    this.tabs.forEach((tab) => {
      tab.classList.remove('tab-title--active');
    });

    if (this.content[index]) {
      this.content.forEach((content) => {
        content.dataset.tabContentVisible = 'false';
      });

      this.tabs[index].classList.add('tab-title--active');
      this.content[index].dataset.tabContentVisible = 'true';
    }
  }
}

if (!customElements.get('tabbed-content')) {
  customElements.define('tabbed-content', TabbedContent);
}
